import { SortOrder } from '@getaccept/lib-shared-new/src/enums/sort-order';
import type { LoadPostsPayload } from '../../types/post';
import { PostSortBy } from '../../types/enums/post-sort-by';

export class FeedConstants {
  static sharedDefaultPayload: Partial<LoadPostsPayload> = {
    limit: 10,
    offset: 0,
    sortOrder: SortOrder.Desc,
  };

  static defaultPayload: Partial<LoadPostsPayload> = {
    ...FeedConstants.sharedDefaultPayload,
    sortBy: PostSortBy.CreatedAt,
  };
}
